jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();

  if ($('#hdnFileName').length > 0) {
    $('img[src*="' + $('#hdnFileName').val() + '"]').parents('.greeting-card').addClass('active');
    $('.ctas-rotate').cycle('goto', $('.greeting-card.active').parent().index());
  }

  $('.additional-filters__toggle').on('click', function () {
    $('.additional-filters').toggleClass('additional-filters--open');
  });

  //Parallax Images
  var images = document.querySelectorAll('.cta-billboard img');
  new simpleParallax(images, {
    orientation: 'right'
  });

  $(window).on('scroll resize', function () {
    $('.cta-billboard').each(function () {
      if ($(window).scrollTop() + $(window).height() >= $(this).position().top && $(window).scrollTop() < $(this).position().top + $(this).height()) {
        if (!$(this).children('.content').hasClass('on-screen')) {
          $(this).children('.content').addClass('on-screen');
        }
      }
      else if ($(this).children('.content').hasClass('on-screen')) {
        $(this).children('.content').removeClass('on-screen');
      }
    });
  });

  $('textarea[data-maxlength]').on('keydown', function (e) {
    var maxlength = $(this).data('maxlength');

    if ($(this)[0].value.length >= maxlength) {
      e.preventDefault();
    }
  });

  $(".tooltip").on('click', function () {
    $(this).toggleClass('tooltip-open');
  });

  $('.filter-dropdown-toggle').on('click', function () {
    $(this).parent().toggleClass('open');
  });

  $('body').on('error', '.physician__image', function () {
    console.log('image error');
    $(this).attr('src', "/themes/memorial/assets/dist/images/photo-unavailable.jpg");
  });
});